import { ArrowRight } from 'lucide-react';
import Button from '../ui/Button';
import { useLanguage } from '../../context/LanguageContext';
import { getFeaturedTeam } from '../../data/team';

export default function AboutTeaser() {
  const { t, language } = useLanguage();
  const chef = getFeaturedTeam()[0]; // Get the head chef

  return (
    <section className="py-16 md:py-24 bg-white dark:bg-gray-800 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Section */}
          <div className="relative">
            {/* Main image */}
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={chef.image}
                alt={chef.name}
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
              {/* Chef name overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
                <p className="text-accent-400 text-sm font-medium mb-1">
                  {t('aboutTeaser.chef')}
                </p>
                <h3 className="text-white text-2xl font-display font-bold">
                  {chef.name}
                </h3>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-200 dark:bg-primary-900/30 rounded-full -z-10" />
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-accent-200 dark:bg-accent-900/30 rounded-full -z-10" />
          </div>

          {/* Content Section */}
          <div className="lg:pl-8">
            <p className="text-accent-600 dark:text-accent-400 font-medium mb-2">
              {t('aboutTeaser.subtitle')}
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6">
              {t('aboutTeaser.title')}
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
              {t('aboutTeaser.description')}
            </p>
            <p className="text-gray-600 dark:text-gray-400 mb-8">
              {chef.bio[language]}
            </p>
            <Button to="/about" variant="outline">
              {t('aboutTeaser.learnMore')}
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
